"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondsBetweenDates = void 0;
const secondsBetweenDates = (startDate, endDate) => {
    return Math.round((endDate - startDate) / 1000);
};
exports.secondsBetweenDates = secondsBetweenDates;
